import React from 'react';
import styled from 'styled-components';
import classnames from 'classnames';

import { Row, Col, Button, DropdownItem, Nav, NavItem, NavLink, TabContent, TabPane, Label } from 'reactstrap';

import styledMagstimTabsWrapper from 'common/controls/StyledMagstimTabsWrapper'
import { MagstimHeaderBar, MagstimDropdown, MagstimColor, CurrentLang, CurrentTheme, isPDA } from "common";

import * as CsvUtils from 'common/utils/CsvUtils';

import { clinicAnalyticsRoutesBase, clinicRoute } from 'routes';
import { deviceAnalyticsRoutesBase, deviceRoute } from 'routes';
import { treatersRoutesBase, treaterRoute } from 'routes';
import { patientAnalyticsRoutesBase, patientRoute } from 'routes';
import { organisationAnalyticsRoutesBase, organisationRoute } from 'routes';

class TableChartTabViewBase extends React.Component {

    constructor(props) {
        super(props);

        // #MAGS-1680 - URLs can potentially become too long 
        // Any Guids set on the state, when the page loads are saved in local storage (so they can be read if the page is refreshed) and on our state
        var guids = [];

        if(props !== undefined && props.location !== undefined && props.location.state !== undefined && props.location.state.Guids !== undefined){
            
            // Grab any Guids that are set on the state and save them to local storage
            guids = this.props.location.state.Guids;
            localStorage.setItem(props.location.pathname, JSON.stringify(this.props.location.state.Guids))

        }else if(props !== undefined && props.location !== undefined && props.location.pathname !== undefined){

            // No Guids set on the state. So try and read them back from local storage
            var routeState = localStorage.getItem(props.location.pathname)
            if(routeState !== null && routeState !== undefined){
                guids = JSON.parse(routeState)
            } 
        }

        this.state = {
            Guids:guids,
            tableHeight: isPDA() ? 'calc(100vh - 400px)' : 'calc(100vh - 200px)',
            chartHeight: isPDA() ? 300 : 500,
            wrapperClassName: isPDA() ? 'ml-3 mr-3' : 'ui-fillh ui-bg ui-bg-no-row-margin',
            headerClassName: isPDA() ? "ui-header" : "ui-header pr-3",
            selectOptions: [],
            exportDisabled: true,
            exportFileName: undefined,
            exportFileNamePrefix:undefined,
            selectedFilter: undefined,
            activeTab: CurrentLang().analytics_summary,
            summaryData: {},
            summaryTabTitle: CurrentLang().analytics_summary,
            filterOptions: [],
            apiData: undefined,
            showFilter:true,
            titleWidth:9,
            filterWidth:3,
            filterIcon: 'fas fa-calendar-alt',
            tabItems:this.getTabItems(),
            helpText:CurrentLang().no_data
        }

        this._table = React.createRef();
        this._summaryTable = React.createRef();
        this._filter = React.createRef();
    }

    // To create custom tabs override getTabItems and getTabBody
    getTabItems(){
        return [
            {
                title:CurrentLang().analytics_data
            },
            {
                title: CurrentLang().analytics_chart
            }];
    }

    getTabBody = (index) => {

        switch (index) {
            case 0:
                return this.getTableWithExportButton();
            case 1:
                return this.getChart()
            default:
                return <></>;
        }
    }

    onTabItemClick = (tabId) => {
        this.activeKey = tabId;
        this.setState({ activeTab: tabId });
    }

    onSelectFilter = (id) => {
        this.setState({ selectedFilter: id }, () => this.onFilterChanged())
    }

    onFilterChanged = () => {
        alert(' Override in derived class');
    }

    loadDataFromAPI() {
        alert(' Override in derived class');
    }

    // eslint-disable-next-line no-unused-vars
    onClickExportTable = (event) => {

        var filename;
        if (undefined === this.state.exportTableFileName) {
            filename = this.state.exportFileName;
        }
        else {
            filename = this.state.exportTableFileName;
        }

        if(this.state.exportFileNamePrefix !== undefined){
            filename = `${this.state.exportFileNamePrefix} - ${filename}`;
        }

        //console.log(`onClickExportTable filename=${filename}`);

        if (this._table !== undefined && this._table !== null) {
            CsvUtils.downloadAsCSV(document, filename, this._table.current.getColumns(), this._table.current.getFilteredData());
        }
    }

    // eslint-disable-next-line no-unused-vars
    onClickExportSummary = (event) => {

        var filename;
        if (undefined === this.state.exportSummaryFileName) {
            filename = this.state.exportFileName;
        }
        else {
            filename = this.state.exportSummaryFileName;
        }

        if(this.state.exportFileNamePrefix !== undefined){
            filename = `${this.state.exportFileNamePrefix} - ${filename}`;
        }

        //console.log(`onClickExportSummary filename=${filename}`);

        if (this._summaryTable !== undefined && this._summaryTable !== null) {
            CsvUtils.downloadAsCSV(document, filename, undefined, this._summaryTable.current.getNamedValuePairs(this.state.summaryData));
        }
    }

    handleError(error) {
        console.log(error);
        if (this.props.handleError !== undefined) {
            this.props.handleError(error);
        }
    }

    componentDidMount() {
        this.loadDataFromAPI();
    }

    componentWillUnmount() {
        this.props.setCurrentPatientID("");
        this.props.setBreadcrumbItem("", "");
    }

    onShowClinic = (guid) => {
        this.props.history.push({ pathname: `${clinicAnalyticsRoutesBase}/${clinicRoute}/${guid}` })
    }

    onShowDevice = (guid) => {
        this.props.history.push({ pathname: `${deviceAnalyticsRoutesBase}/${deviceRoute}/${guid}` })
    }

    onShowTreater = (guid) => {
        this.props.history.push({ pathname: `${treatersRoutesBase}/${treaterRoute}/${guid}` })
    }

    onShowPatient = (guid) => {
        this.props.history.push({ pathname: `${patientAnalyticsRoutesBase}/${patientRoute}/${guid}` })
    }

    onShowOrganisation = (guid) => {
        this.props.history.push({ pathname: `${organisationAnalyticsRoutesBase}/${organisationRoute}/${guid}` })
    }

    init(data) {

        // Just set the filter here and save the data in the state
        var filterOptions = [];
        var selectedFilter = this.state.selectedFilter;

        // Populate
        for (var item in data) {
            filterOptions.push(item);
        }

        // Default to the first option 
        if (selectedFilter === undefined && filterOptions.length > 0) {
            selectedFilter = filterOptions[0];
        }

        this.setState({ apiData: data, filterOptions: filterOptions, selectedFilter: selectedFilter, exportDisabled:false }
            , () => {
                this.onFilterChanged();
            });
    }

    // Iterate over the selected filter API data - callas back with each summary item, checking for null and undefined objects
    apiDataFilterIterator = (callback) =>{

        if(this.state.apiData !== null && this.state.apiData !== undefined){

            const data = this.state.apiData;

            if (data[this.state.selectedFilter] !== undefined && data[this.state.selectedFilter] !== null) {
                if (data[this.state.selectedFilter].Map !== undefined && data[this.state.selectedFilter].Map !== null) {
                    
                    const selectedDataMap =  data[this.state.selectedFilter].Map;

                    if(selectedDataMap !== null && selectedDataMap !== undefined){
                        for (var item in selectedDataMap) {
                            if (item !== null && item !== undefined) {
                                var summaryItem = selectedDataMap[item];
                                if (summaryItem !== undefined && summaryItem !== null) {
                                    callback(summaryItem);
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    getSelectedDataMap = () => {
        const data = this.state.apiData;

        if (data[this.state.selectedFilter] !== undefined && data[this.state.selectedFilter] !== null) {
            if (data[this.state.selectedFilter].Map !== undefined && data[this.state.selectedFilter].Map !== null) {
                return data[this.state.selectedFilter].Map;
            }
        }

        return null;
    }

    getSelectedDataSummary = () => {
        const data = this.state.apiData;

        if (data[this.state.selectedFilter].Summary !== undefined && data[this.state.selectedFilter].Summary != null) {
            return data[this.state.selectedFilter].Summary;
        }

        return null;
    }

    populateChart = (chart, chartDataItems, yAxisLabel) =>{

        chartDataItems.sort(function(a, b) {
            var nameA = a.x.toUpperCase(); // ignore upper and lowercase
            var nameB = b.x.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
          
            // names must be equal
            return 0;
          })

        const chartData = {
            xAxisGroupLabels: chartDataItems.map(item => {return item.x}),
            xAxisLabel: '',
            yAxisLabel: yAxisLabel,
            data: [{
                label: '',
                values:  chartDataItems.map(item => {return item.y}),
                color: MagstimColor.MagstimPurple
            }]
        };

        chart.current.init(chartData, this.onClickBar);
        this.setState({itemGuids: chartDataItems.map(item => {return item.guid})});
    }

    getSummary = () => {
        return <div className="table-area mt-2 mb-2"></div>;
    }

    getChart = () => {
        return <div className="table-area mt-2 mb-2"></div>;
    }

    getTable = () => {
        return <div className="table-area mt-2 mb-2"></div>;
    }

    calculateAverageAccuracyItem(progressItem){
        if (progressItem.SumPulses > 0) {
            progressItem.AveragePulsesWithinTolerance = (100 * (progressItem.SumPulsesWithinTolerance / progressItem.SumPulses));
            progressItem.AveragePulsesWithinContactTolerance = (100 * (progressItem.SumPulsesWithinContactTolerance / progressItem.SumPulses));
            progressItem.AveragePulsesWithinDistanceTolerance = (100 * (progressItem.SumPulsesWithinDistanceTolerance / progressItem.SumPulses));
            progressItem.AveragePulsesWithinRotationTolerance = (100 * (progressItem.SumPulsesWithinRotationTolerance / progressItem.SumPulses));
            progressItem.AveragePulsesWithinTiltTolerance = (100 * (progressItem.SumPulsesWithinTiltTolerance / progressItem.SumPulses));
        }
    }

    getTableWithExportButton = () => {
        return <>
            {this.getTable()}
            <Col className="pt-1 pb-2 pr-0 mt-3 mr-3 text-right">
                <Button color="primary" disabled={this.state.exportDisabled} className="pl-5 pr-5" onClick={this.onClickExportTable} size={CurrentTheme().ControlSize} ><i className="fas fa-file-excel pr-2"></i> {CurrentLang().table_export_title}</Button>
            </Col>
        </>;
    }

    getFilterHeaderItems(){
        
        let filterHeaderItems = [];

        for(var index = 0; index < this.state.filterOptions.length; index++ ){
 
            const  item = <DropdownItem id={this.state.filterOptions[index]} key={this.state.filterOptions[index]}>{CurrentLang()[`filter_option_${this.state.filterOptions[index].toLowerCase()}`]}</DropdownItem>
            
            filterHeaderItems.push(item);

            if(index === 0){
                filterHeaderItems.push(<DropdownItem key="divider" divider />);
            }
        }

        return filterHeaderItems;
    }

    getFilter(){
        let filterHeaderItems = this.getFilterHeaderItems();

        var filter = <></>;

        if(this.state.showFilter === true){
            filter = <MagstimDropdown id="filterDropdown" ref={this._filter} onSelect={this.onSelectFilter} icon={this.state.filterIcon} dropDownKey={this.state.selectedFilter}>
                    {filterHeaderItems}
                </MagstimDropdown>
        }

        return filter;
    }

    render() {

        const filter = this.getFilter();

        const header = <> <Row className={this.state.headerClassName}>
            <Col md={this.state.titleWidth}  sm="12" >
                <MagstimHeaderBar
                    main_title={this.state.activeTab}
                    ShowClose={false}>
                </MagstimHeaderBar>
            </Col>

            <Col md={this.state.filterWidth} sm="12" className="mt-auto mb-auto">
                {filter}
            </Col>
        </Row>
        </>

        var summaryExportButton = <>
            <Col className="pt-1 pr-0 mt-3 mr-3 mb-3 text-right">
                <Button data-testid="export-button" color="primary" disabled={this.state.exportDisabled} className="pl-5 pr-5" onClick={this.onClickExportSummary} size={CurrentTheme().ControlSize} ><i className="fas fa-file-excel pr-2"></i> {CurrentLang().table_export_title}</Button>
            </Col>
        </>

        const tabSummary =  <TabPane key={this.state.summaryTabTitle} tabId={this.state.summaryTabTitle} className="pl-0" title={this.state.summaryTabTitle}>
                                {header}
                                <Row className="ui-bg">
                                <Col md="6" sm="12" className="mt-3 mb-3" >
                                    <Label className="line-break-label">{this.state.helpText}</Label>
                                    </Col>
                                    <Col md="6" sm="12" >
                                        {this.getSummary()}
                                        {summaryExportButton}
                                    </Col>
                                </Row>
                            </TabPane>
        

        var navItems = [];
        var tabBodies = [];

        tabBodies.push(tabSummary);
        navItems.push(
            <NavItem key={this.state.summaryTabTitle}>
                <NavLink
                    className={classnames({ active: this.state.activeTab === this.state.summaryTabTitle })}
                    onClick={() => { this.onTabItemClick(this.state.summaryTabTitle); }}>
                    {this.state.summaryTabTitle}
                </NavLink>
            </NavItem>
        );

        for (var i = 0; i < this.state.tabItems.length; i++) {

            const tabName = this.state.tabItems[i].title;

            navItems.push(
                <NavItem key={tabName}>
                    <NavLink
                        className={classnames({ active: this.state.activeTab === tabName })}
                        onClick={() => { this.onTabItemClick(tabName); }}>
                        {tabName}
                    </NavLink>
                </NavItem>
            );

            tabBodies.push(          
                    <TabPane key={tabName} tabId={tabName} className="pl-0" title={tabName}>
                        {header}
                        <Row className="ui-bg">
                            <Col>
                                <Col className="pl-0 pr-0">
                                    <div className="chart-area">
                                        {this.getTabBody(i)}
                                    </div>
                                </Col>
                            </Col>
                        </Row>
                    </TabPane>
            );
        }

        const body = <>
            <Nav tabs className="border-bottom mb-1">
                {navItems}
            </Nav>

            <TabContent className="mt-1 ml-3 mr-3" activeTab={this.state.activeTab} >
                {tabBodies}
            </TabContent>
        </>

        return (
            <Wrapper className={this.state.wrapperClassName} tableHeight={this.state.tableHeight}>
                {body}
            </Wrapper>
        );
    }
}

const Wrapper = styled(styledMagstimTabsWrapper)`

	.ui-header{
		color: ${MagstimColor.MagstimGroupHeaderText};
		background-color: ${MagstimColor.MagstimCardHeaderBackground};
	}

	.device-chart{
		padding-right:20px;
    }
    
    .line-break-label{
        white-space: pre-wrap;
        padding-left:16px;
        padding-right:16px;
        padding-top:8px;
        padding-bottom:8px;
    }

`;


export default TableChartTabViewBase;